// 原来16px===1rem；新的100px===1rem;旧的先乘16除100
// var winWidth = document.documentElement.offsetWidth || document.body.offsetWidth;
// winWidth = winWidth < 1366 ? 1366 : winWidth;
// var oHtml = document.getElementsByTagName('html')[0];
// oHtml.style.fontSize = 16 * winWidth / 1920 + 'px';

// window.addEventListener('resize', function () {
//     var winWidth = document.documentElement.offsetWidth || document.body.offsetWidth;
//     winWidth = winWidth < 1366 ? 1366 : winWidth;
//     var oHtml = document.getElementsByTagName('html')[0];
//     oHtml.style.fontSize = 16 * winWidth / 1920 + 'px';
// })
/**
 * @desc 自适应宽度
 * @param {number} designWidth 设计稿宽带 默认 1920
 * @param {number} maxWidth 最大宽度，缩大到一定程度不在缩大 默认 无限制
 * @param {number} minWidth 最小宽度，缩小到一定程度不在缩小 默认 1366
 * @param {number} base 基准值 默认 100(100px === 1rem)
 * 只对rem单位有效，对px单位是无效的;minWidth: 1280因为首页app.vue的body设置min-width:1280px
 */
(({ designWidth = 1920, maxWidth = 2 ** 64, minWidth = 1366, base = 100 }) => {
  autoComputed();
  window.addEventListener('resize', autoComputed);
  function autoComputed() {
    let html = document.documentElement || document.body;
    let limitMax = maxWidth / designWidth;
    let limitMin = minWidth / designWidth;
    let scale = document.body.offsetWidth / designWidth;

    html.style.fontSize = ((scale < limitMin ? limitMin : (scale > limitMax ? limitMax : scale)) *base).toFixed(2) + 'px';
  }
})({ minWidth: 1280 });



// WEBPACK FOOTER //
// ./src/utils/flexible.js